import React, { FC } from 'react';

import { getCompetitionLabel } from '../../utils/getCompetitionLabel';

import styles from './_SportBaseEventMeta.module.css';

interface SportBaseEventMetaProps {
    sportName?: string;
    competitionName?: string;
    eventTitle?: string;
}

export const SportBaseEventMeta: FC<SportBaseEventMetaProps> = ({
    sportName,
    competitionName,
    eventTitle,
}) => {
    const competitionLabel = getCompetitionLabel(sportName, competitionName);

    return (
        <div className={styles.sportBaseEventMeta}>
            {competitionLabel && <div className={styles.competitionLabel}>{competitionLabel}</div>}
            <div className={styles.eventTitle}>{eventTitle}</div>
        </div>
    );
};
